import * as Accordion from "@radix-ui/react-accordion";
import {
  ComponentPropsWithoutRef,
  ElementRef,
  forwardRef,
  PropsWithChildren,
} from "react";
import * as SC from "./header.styles";

type HeaderProps = PropsWithChildren<
  ComponentPropsWithoutRef<typeof SC.Header>
>;

export const Header = forwardRef<
  ElementRef<typeof Accordion.Header>,
  HeaderProps
>(({ children, ...props }, ref) => (
  <SC.Header ref={ref} {...props}>
    {children}
  </SC.Header>
));

Header.displayName = "CustomTriggerAccordionGroup.Header";
